import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  Country: {
    to: 'CountryLookupUI',
  },
  Currency: {
    to: 'CurrencyLookupUI',
  },
  DeveloperActions: {
    to: 'DeveloperMenuUI',
  },
  EventLog: {
    to: 'EventLogUI',
  },
  HelpVideo: {
    to: 'HelpVideoUI',
  },
  HelpVideoGroup: {
    to: 'HelpVideoGroupUI',
  },
  Municipality: {
    to: 'MunicipalityLookupUI',
  },
  NeosDataImport: {
    to: 'NeosDataImportTemplateEditUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  ProvinceState: {
    to: 'ProvinceStateLookupUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  },
  WhatsNew: {
    to: 'WhatsNewUI',
  }
}